import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Space+Grotesk:wght@400;500;700&display=swap');
:root {
  --primary100: #F0F1F5;
  --primary200: #A6ACC1;
}

* {
  margin: 0;
  padding: 0;
  outline: 0;
  font-family: 'Montserrat', sans-serif;
}

a {
  text-decoration: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

body {
  font-family: 'Montserrat', sans-serif;
  background: #1F1F1F;
  -webkit-font-smoothing: antialiased;
}

html {
  scroll-behavior: smooth;
}


`;
